import React from "react";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { SubscriptionTotalApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";

interface Props {
	totals?: SubscriptionTotalApi[];
}

const SubscriptionTotalPrice = ({ totals }: Props) => {
	const yearlyTotalPrice = totals?.find((total) => total.billing_period === "YEARLY");
	const monthlyTotalPrice = totals?.find((total) => total.billing_period === "MONTHLY");

	if (yearlyTotalPrice) {
		return (
			<>
				<h6 className="mb-0">{FormatMoney(yearlyTotalPrice.total_price)}/rok</h6>
				{monthlyTotalPrice && (
					<span style={{ fontSize: "12px" }}>+ {FormatMoney(monthlyTotalPrice.total_price)}/mies.</span>
				)}
			</>
		);
	} else if (monthlyTotalPrice) return <h6>{FormatMoney(monthlyTotalPrice.total_price)}/mies.</h6>;

	return <></>;
};

export default SubscriptionTotalPrice;
